// coords.ts ↔ game/game.cpp:700-752 InitCoordMappingTables + the ht.h:776-830
// pixel↔world inlines. Pixel coords are RENDER-scale (gcxTile = 32 for 2432 art,
// 24 for 824): wc = pc*256/gcxTile via a table, and the INVERSE table is built
// with the overflow loop below so the round-trip pcFromWc[wcFromPc[pc]] == pc
// holds exactly (NOT a plain wc*gcxTile/256 — transliterated verbatim).

export const ktcMax = 64; // ht.h:758
export const kwcMax = ktcMax * 256; // ht.h:760
export const kpcMax = ktcMax * 32; // ht.h:759

export class CoordMap {
  readonly gcxTile: number;
  readonly gcyTile: number;
  private wcFromPc: Int16Array; // [64*32*2 + 1]
  private pcFromWc: Int16Array; // [kwcMax]

  constructor(gcxTile: number) {
    this.gcxTile = gcxTile;
    this.gcyTile = gcxTile; // square tiles in every shipped mode

    // game.cpp:737-748 — pixel -> world
    this.wcFromPc = new Int16Array(64 * 32 * 2 + 1);
    for (let i = 0; i <= 64 * 32; i++) {
      this.wcFromPc[i] = Math.floor((i * 256) / gcxTile);
    }

    // game.cpp:713-733 — world -> pixel (the overflow loop, verbatim)
    this.pcFromWc = new Int16Array(kwcMax);
    let s = 0;
    let nOverflow = 0;
    for (let i = 0; i < kwcMax; i++) {
      this.pcFromWc[i] = s;
      nOverflow += gcxTile;
      if (nOverflow === 256) {
        nOverflow = 0;
        s++;
      } else if (nOverflow > 256) {
        nOverflow -= 256;
      } else if (nOverflow + gcxTile - 1 >= 256) {
        s++;
      }
    }
  }

  // ht.h:786-795
  WcFromPc(pc: number): number {
    return pc >= 0 ? this.wcFromPc[pc] : -this.wcFromPc[-pc];
  }

  // ht.h:801-807
  PcFromWc(wc: number): number {
    return wc >= 0 ? this.pcFromWc[wc] : -this.pcFromWc[-wc];
  }

  // ht.h:809-811
  TcFromPc(pc: number): number {
    return this.WcFromPc(pc) >> 8;
  }

  // ht.h:782-784 — the pixel offset within its tile
  PcFracFromUpc(pc: number): number {
    return this.pcFromWc[this.wcFromPc[pc] & 0xff];
  }

  // ht.h:813-826
  WcFromUpc(pc: number): number {
    return this.wcFromPc[pc];
  }
  PcFromUwc(wc: number): number {
    return this.pcFromWc[wc];
  }
  TcFromUpc(pc: number): number {
    return this.wcFromPc[pc] >> 8;
  }
}
